import { Link } from 'react-router';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface CartaoIndicadorProps {
  rotulo: string;
  valor: number;
  icone: LucideIcon;
  /** Classes de cor do ícone, alinhadas ao status representado. */
  tom?: string;
  /** Quando informado, o cartão vira um atalho para a lista já filtrada. */
  para?: string;
  descricao?: string;
}

export function CartaoIndicador({
  rotulo,
  valor,
  icone: Icone,
  tom = 'bg-silenciado text-silenciado-texto',
  para,
  descricao,
}: CartaoIndicadorProps) {
  const conteudo = (
    <>
      <span className={cn('flex size-9 shrink-0 items-center justify-center rounded-lg', tom)}>
        <Icone className="size-4.5" aria-hidden="true" />
      </span>
      <span className="min-w-0">
        <span className="block text-2xl leading-tight font-semibold tabular-nums">{valor}</span>
        <span className="text-silenciado-texto block text-sm">{rotulo}</span>
        {descricao && <span className="text-silenciado-texto block text-xs">{descricao}</span>}
      </span>
    </>
  );

  const classes = 'bg-cartao flex items-start gap-3 rounded-xl border p-4 transition-colors';

  if (para) {
    return (
      <Link
        to={para}
        className={cn(
          classes,
          'hover:border-marca focus-visible:outline-foco focus-visible:outline-2',
        )}
      >
        {conteudo}
      </Link>
    );
  }

  return <div className={classes}>{conteudo}</div>;
}
